module.exports = __webpack_public_path__ + "img/pin.599c9e87.svg";